module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.2b401911.svg";